var $ = require("jquery");
var $document = $(document);

var getSlideContainers = function () {
    return $('[data-slide-container]').not('[data-dont-slide]');
};


var bindEvents = function ($slideContainer) {

    var $trigger = $('[data-slide-button="trigger"]', $slideContainer);
    var $showButton = $('[data-slide-button="show-button"]', $slideContainer);
    var $hideButton = $('[data-slide-button="hide-button"]', $slideContainer);
    var $contentTarget = $('[data-slide-content="content"]', $slideContainer);

    $trigger.off('click.ctrlSlide');
    $trigger.on('click.ctrlSlide', function (e) {
        e.preventDefault();

        $contentTarget.stop().slideToggle('500');
        $showButton.toggleClass("a-btn-more--hidden");
        $hideButton.toggleClass("a-btn-more--hidden");
    });

};

var init = function () {
    var $slideContainers = getSlideContainers();
    $slideContainers.each(function () {
        var $slideContainer = $(this);
        bindEvents($slideContainer);
    });
};

init();

$document.off('jsInitAllScripts.ctrlSlide');
$document.on('jsInitAllScripts.ctrlSlide', function () {
    init();
});


// WEBPACK FOOTER //
// ./Sig.Web/src/controller/ctrl-slide/ctrl-slide.chunk.js